<div class="camera-control-container dialog">
    <div mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle
        class="d-flex justify-content-between align-items-center w-100">
        <h3>{{ camTitle }}&nbsp;{{ stationName }}</h3>
        <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg" alt="close-modal-icon"
            (click)="onCloseDialogClicked()">
    </div>
    <div *ngIf="isExpired" class="refresh-container">
        <p>Die Ansicht wurde nach 3 Minuten deaktiviert.</p>
        <div class="d-flex justify-content-center">
            <button mat-raised-button color="primary" (click)="onRefreshClicked()">
                Ansicht aktualisieren
            </button>
        </div>
    </div>
    <!-- Auto-Refresh Controls -->
    <div class="auto-refresh-section">
        <div class="d-flex align-items-center justify-content-between">
            <span class="fw-semibold">Einstellungen</span>

            <mat-button-toggle-group name="view" [value]="selectedView">
                <mat-button-toggle value="Stream" (click)="switchToStream()">
                    Stream
                </mat-button-toggle>
                <mat-button-toggle value="Bild" (click)="switchToSnapshot()">
                    Bild
                </mat-button-toggle>

            </mat-button-toggle-group>

        </div>
        <div *ngIf="!isExpired && selectedView === 'Bild'" class="refresh-controls">
            <!-- Interval Selection -->
            <div class="interval-selection">
                <label for="intervalSelect">Intervall:</label>
                <select id="intervalSelect" [(ngModel)]="selectedInterval" (change)="onIntervalChange()"
                    [disabled]="!rs" class="interval-select">
                    <option *ngFor="let interval of availableIntervals" [value]="interval.value">
                        {{ interval.label }}
                    </option>
                </select>
            </div>

            <!-- Toggle Auto-Refresh -->
            <div class="toggle-section">
                <div>
                    <label class="toggle-container">
                        <input type="checkbox" [(ngModel)]="autoRefreshEnabled" (change)="toggleAutoRefresh()"
                            [disabled]="!rs">
                        <span class="toggle-slider"></span>
                        <span class="toggle-label">
                            <!-- autoRefreshEnabled ? 'Auto-Refresh' : --> {{ 'Auto-Refresh' }}
                        </span>
                    </label>
                </div>
                <div>
                    <div class="last-update" *ngIf="lastSnapshotTime">
                        <small>Letztes Update: {{ getFormattedLastUpdate() }}</small>
                    </div>
                </div>
            </div>


        </div>
    </div>

    <!-- Snapshot Section -->
    <div *ngIf="!isExpired && selectedView === 'Bild'" class=" snapshot-section">

        <div class="image-container">
            <div *ngIf="snapshotUrl; else noImageTemplate">
                <img [src]="snapshotUrl" alt="Camera Snapshot" class="camera-snapshot">

                <!-- Auto-Refresh Overlay -->
                <div class="refresh-overlay" *ngIf="autoRefreshEnabled">
                    <div class="refresh-indicator">
                        <span class="refresh-icon">🔄</span>
                        <span>{{ timeLeft }}s</span>
                    </div>
                </div>
            </div>

            <ng-template #noImageTemplate>
                <div class="no-image">
                    <p>Kein Snapshot verfügbar</p>
                    <small *ngIf="!rs">Bitte RouteStation ID eingeben</small>
                </div>
            </ng-template>
        </div>
    </div>

    <div *ngIf="!isExpired && selectedView === 'Stream'" class="stream-section">
        <img #streamImg *ngIf="!isExpired && selectedView === 'Stream'" [src]="" class="camera-snapshot" />
    </div>

    <!-- PTZ Controls  -->
    <div class="ptz-controls" *ngIf="isCamWithControls">
        <h3> Kamera-Steuerung</h3>

        <div class="d-flex justify-content-around">
            <div class="movement-controls">
                <div class="control-row">
                    <button (click)="moveUp()" [disabled]="!rs" class="btn btn-secondary control-btn">
                        ⬆️ Hoch
                    </button>
                </div>

                <div class="control-row">
                    <button (click)="moveLeft()" [disabled]="!rs" class="btn btn-secondary control-btn">
                        ⬅️ Links
                    </button>
                    <button (click)="moveToHome()" [disabled]="!rs" class="btn btn-secondary control-btn">
                        🏠 Home
                    </button>
                    <button (click)="moveRight()" [disabled]="!rs" class="btn btn-secondary control-btn">
                        ➡️ Rechts
                    </button>
                </div>

                <div class="control-row">
                    <button (click)="moveDown()" [disabled]="!rs" class="btn btn-secondary control-btn">
                        ⬇️ Runter
                    </button>
                </div>
            </div>

            <div class="zoom-controls">

                <button (click)="zoomIn()" [disabled]="!rs || currentZoom >= 9999" class="btn btn-success control-btn">
                    🔍+ Zoom In
                </button>

                <button (click)="zoomOut()" [disabled]="!rs || currentZoom <= 1" class="btn btn-warning control-btn">
                    🔍- Zoom Out
                </button>
                <div class="d-flex justify-content-center">
                    <div *ngFor="let position of positions" class="me-1">
                        <div class="d-flex flex-column">
                            <button [disabled]="!position.found" mat-mini-fab color="none"
                                (click)="goToPosition(position.name)"
                                [ngClass]="position.found ? 'fw-semibold' : 'text-danger'">
                                {{ position.name }}
                            </button>
                            <img *ngIf="position.found" class="avs-icon-delete p-2" src="assets/icons/trash.svg"
                                alt="icon-save-position" height="40" (click)="deletePosition(position.name)">
                            <img *ngIf="!position.found" class="avs-icon-save p-2" src="assets/icons/save-floppy.svg"
                                alt="icon-delete-position" height="40" (click)="saveCurrentPosition(position.name)">
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</div>